import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import ErrorPage from '~/components/ErrorPage';
import InvalidLink from '~/routes/InvalidLink';
import { translate as t, createTranslate } from '~/utils/translation';


const tt = createTranslate('routes.payment_return');


// /return is the redirect target of a payment popup (Bancontact/iDEAL through Stripe, see
// bancontact.js and ideal.js): the page that opened the popup polls Stripe for the result, so
// the popup only has to close. Old openers set `window.receiveFunctionName` to get the query
// back; that hand-off still runs if an opener asks for it.
// Without an opener, Stripe's redirect params (?source=src_...&client_secret=...&livemode=...)
// mean the payment step most likely just finished in a window that lost its opener (or was
// opened as a tab): a neutral "you can close this window" page. Without them either (a
// bookmark, a link copied by hand), the invalid link page.


function hasStripeRedirectParams(query) {
  return Boolean(query?.source || query?.client_secret);
}


const PaymentStepCompleted = () => (
  <ErrorPage
    modifier="paymentReturn"
    titleAs="h1"
    title={tt('title')}
    subtitle={tt('subtitle')}
    action={{ label: tt('back'), href: '/' }}
  />
);


// Hands the query to the opener's receive function, if it has one. A cross-origin opener
// (the popup reached /return from another site's window) throws a SecurityError on any
// property access; nothing to hand over then. Any other failure is reported, and the popup
// still closes.
function sendToOpener(opener, query) {
  try {
    const receive = opener[opener.receiveFunctionName];
    if (typeof receive === 'function') {
      receive.call(opener, query);
    }
  }
  catch (error) {
    if (error?.name !== 'SecurityError') {
      console.reportException(error, { from: 'pods/transactions/utils/payments/Return' });
    }
  }
}


class Return extends React.Component {

  componentDidMount() {
    this._sendDataBack();
  }

  componentDidUpdate() {
    this._sendDataBack();
  }

  render() {
    const { query } = this.props;
    if (window.opener != null) {
      return (
        <div></div>
      );
    }
    if (hasStripeRedirectParams(query)) {
      return <PaymentStepCompleted />;
    }
    return <InvalidLink action={{ label: t('routes.not_found.back_home'), href: '/' }} />;
  }

  _sendDataBack() {
    const { query } = this.props;
    const opener = window.opener;
    if (opener != null) {
      sendToOpener(opener, query);
      window.close();
    }
    else if (hasStripeRedirectParams(query)) {
      // closes the window if a script opened it; a no-op otherwise, and the page stays
      window.close();
    }
  }

}


export default connect((state, ownProps) => ({
  query: queryString.parse(ownProps.location.search),
}))(Return);
